import { Text } from 'slate';

export function isText(value: unknown): value is Text {
  return Text.isText(value);
}
